<div #container class="mood" tabindex="0" (keydown)="onKeyDown($event)">
  <input
    type="date"
    name="borderDate"
    [(ngModel)]="borderDate"
    (change)="onChange($event)"
  />
  <!-- <ngx-timepicker-field
    name="borderTime"
    [format]="24"
    [(ngModel)]="borderTime"
    (change)="onChange($event)"
  ></ngx-timepicker-field> -->
  <input
    type="time"
    name="borderTime"
    [(ngModel)]="borderTime"
    (change)="onChange($event)"
  />
</div>
